import { useEffect, useState } from "react";
import { CAT_LABEL, CATEGORIES, SPECIAL_GKK } from "@/lib/constants";
import { api } from "@/lib/api";
import { sInput, sLabel } from "@/components/staff/Bits";
import { GkkOptions } from "@/components/FormBits";

export function useGkks() {
  const [gkks, setGkks] = useState([]);
  useEffect(() => { api.get("/gkks").then((r) => setGkks(r.data)).catch(() => setGkks([])); }, []);
  return gkks;
}

export const gkkName = (gkks, id) => gkks.find((g) => g.id === id)?.name || Object.fromEntries(SPECIAL_GKK)[id] || id;

export default function Filters({ value, onChange, show = ["date", "category", "gkk"], extra }) {
  const gkks = useGkks();
  const set = (p) => onChange({ ...value, ...p });
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mb-6" data-testid="filters-bar">
      {show.includes("date") && (<>
        <div><label className={sLabel} htmlFor="df">From</label><input id="df" type="date" data-testid="filter-date-from" className={sInput} value={value.date_from || ""} onChange={(e) => set({ date_from: e.target.value })} /></div>
        <div><label className={sLabel} htmlFor="dt">To</label><input id="dt" type="date" data-testid="filter-date-to" className={sInput} value={value.date_to || ""} onChange={(e) => set({ date_to: e.target.value })} /></div>
      </>)}
      {show.includes("category") && (
        <div><label className={sLabel} htmlFor="fc">Category</label>
          <select id="fc" data-testid="filter-category" className={sInput} value={value.category || ""} onChange={(e) => set({ category: e.target.value })}>
            <option value="">All</option>{CATEGORIES.map((c) => <option key={c.code} value={c.code}>{c.code}. {CAT_LABEL[c.code]}</option>)}
          </select></div>)}
      {show.includes("gkk") && (
        <div><label className={sLabel} htmlFor="fg">GKK / community</label>
          <select id="fg" data-testid="filter-gkk" className={sInput} value={value.gkk || ""} onChange={(e) => set({ gkk: e.target.value })}>
            <option value="">All</option><GkkOptions gkks={gkks} /><optgroup label="Other">{SPECIAL_GKK.map(([k, v]) => <option key={k} value={k}>{v}</option>)}</optgroup>
          </select></div>)}
      {extra}
    </div>
  );
}

export const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== "" && v != null && v !== false));
